// socket-init.ts
import io from 'socket.io-client';

interface SocketOptions {
  game: 'starwars' | 'storm'; // Adaptable à d'autres jeux plus tard
  role?: string;
  sessionId?: string;
  teamId?: string;
  userId?: string;
  userName?: string;
}

export function createSocket({
  game,
  role = 'player',
  sessionId = '',
  teamId = '',
  userId = '',
  userName = '',
}: SocketOptions): any {
  // Base path for socket.io depending on game
  const path = `/${game}/socket.io`;

  // Determine base URL
  // If running on port 5751 (Vite Dev), explicit backend URL
  // Otherwise (Production/Docker on 5750), use relative path (undefined)
  const isDevClient = typeof window !== 'undefined' && window.location.port === '5751';

  const baseURL = isDevClient
    ? `http://localhost:${game === 'starwars' ? '5750' : '5800'}`
    : undefined;

  console.log(`Creating socket connection to ${baseURL} with path ${path}`);

  // Create socket with query params and iframe-friendly config
  const socket = io(baseURL, {
    path,
    query: {
      role,
      sessionId,
      teamId,
      userId,
      userName
    },
    transports: ['websocket', 'polling'], // Support iframe avec polling fallback
    timeout: 20000, // Timeout de connexion plus long pour iframe
    forceNew: false, // Réutiliser la connexion si possible
    reconnection: true, // Réconnexion automatique
    reconnectionAttempts: 5, // Nombre de tentatives de reconnexion
    reconnectionDelay: 1000, // Délai initial de reconnexion
    reconnectionDelayMax: 5000, // Délai maximum de reconnexion
    randomizationFactor: 0.5, // Facteur de randomisation
  });

  // Logging
  socket.on('connect', () => {
    console.log(`[${game.toUpperCase()}] ✅ Connected to socket server at: ${baseURL}${path}`);
  });

  socket.on('connect_error', (err: any) => {
    console.error(`[${game.toUpperCase()}] ❌ Socket connection error:`, err.message || err);
  });

  return socket;
}
